import React from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';
import { ReactComponent as svg } from './signUpText.svg';

const SignUpText = (props: SvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 671 234"
      sx={{
        width:'100%',
        height:'100%',
        margin: '0px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        //   '& path': {
        //     fill: theme.colors?.buttonIcon.default
        //   },
        ...props.sx,
      }}
      {...props}
    />
  );
};

export default SignUpText;
